// Generated by scripts/update-seeq-icons.js from src/svg/seeq/pin.svg.
// Do not edit this file directly; update the source SVG and regenerate.
import type { IconDefinition, IconName } from '@fortawesome/fontawesome-common-types';

export const fcPin = {
  prefix: 'fak',
  iconName: 'pin' as IconName,
  icon: [
    1024,
    1024,
    [],
    'e985',
    'M20.5 378.9l307.2-20.5c35.8 0 71.7-15.4 97.3-41l138.2-143.3-35.8-35.9c-5.1-5.1-5.1-15.4 0-25.6l112.6-112.6c5.1 0 15.4 0 25.6 5.1l353.3 353.3c5.1 5.1 5.1 15.4 0 25.6l-112.7 112.6c-5.1 5.1-15.4 5.1-25.6 0l-30.7-35.8-138.2 138.2c-25.6 25.6-41 61.4-41 97.3l-20.5 307.2c0 15.4-20.5 20.5-25.6 10.3l-256-256-271.3 266.2h-97.3v-92.2l266.2-266.2-256-256c-10.2-15.4-5.1-30.7 10.3-30.7z',
  ],
} satisfies IconDefinition;
